import { useNavigation as useRNNavigation } from '@react-navigation/native';

import type {
  AuthDrawerParamList,
  AuthDrawerScreenProps,
  DevelopmentStackParamList,
  DevelopmentStackScreenProps,
  RootStackParamList,
  RootStackScreenProps,
  UnAuthStackParamList,
  UnAuthStackScreenProps,
} from '@/navigations/types';
/**
 * Typed navigation for Development stack (DevelopmentScreen, ComponentScreen).
 * Use when the screen is inside DevelopmentStack to navigate within the stack.
 *
 * @example
 * const navigation = useDevelopmentStackNavigation();
 * navigation.navigate('Component');
 */
export function useDevelopmentStackNavigation() {
  return useRNNavigation<
    DevelopmentStackScreenProps<keyof DevelopmentStackParamList>['navigation']
  >();
}

/**
 * Typed navigation for Auth drawer (Home, Profile, Settings, public screens).
 * Use when the screen is inside Auth Drawer to navigate within the drawer.
 *
 * @example
 * const navigation = useAuthDrawerNavigation();
 * navigation.navigate('Profile');
 */
export function useAuthDrawerNavigation() {
  return useRNNavigation<AuthDrawerScreenProps<keyof AuthDrawerParamList>['navigation']>();
}

/**
 * Typed navigation for UnAuth stack (Login, public screens).
 * Use when the screen is inside UnAuth stack.
 *
 * @example
 * const navigation = useUnAuthStackNavigation();
 * navigation.navigate('Login');
 */
export function useUnAuthStackNavigation() {
  return useRNNavigation<UnAuthStackScreenProps<keyof UnAuthStackParamList>['navigation']>();
}

export function useRootNavigation() {
  const navigation =
    useRNNavigation<RootStackScreenProps<keyof RootStackParamList>['navigation']>();

  return navigation;
}
